export enum OrganizationModuleEnum {
    SPEECH_ANALYSIS = 'SPEECH_ANALYSIS',
    CONVERSATION_ANALYSIS = 'CONVERSATION_ANALYSIS'
}
